import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeNl from '@angular/common/locales/nl';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { TimeagoModule } from 'ngx-timeago';
import { environment } from '../environments/environment';
import { CustomTitleStrategy, routes } from './app.routes';
import { provideAuth } from './auth/auth.provider';
import { provideApollo } from './core/graph-api/graph.provider';
import { providePanels } from './panels/panels.provider';

registerLocaleData(localeNl, 'nl-NL');

export const appConfig: ApplicationConfig = {
  providers: [
    provideServiceWorker('ngsw-worker.js', { enabled: !environment.isDevelopment }),
    provideAuth(),
    provideApollo(),
    providePanels(),
    provideRouter(routes),
    provideZoneChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    provideCharts(withDefaultRegisterables()),
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    importProvidersFrom(TimeagoModule.forRoot()),
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
  ],
};
